import { MovieClipProperties } from "@lib/titan2/dist/game/control/properties/MovieClipProperties";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { ArrayUtil } from "@lib/titan2/dist/util/collection/ArrayUtil";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
import { SlingoStyle } from "../style/SlingoStyle";
/**
 * AbstractSlingoAnimationProperties.ts
 */
export class AbstractSlingoAnimationProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.amountFields.getKeys().every((value, index) => value === other.amountFields.getKeys()[index]) &&
            this.amountFields.getValues().every((value, index) => value.equals(other.amountFields.getValues()[index]));
    }
    setDefaultValues() {
        this.amountFields = new Dictionary();
    }
}
/**
 * AbstractSlingoAnimationSpriteProperties.ts
 */
export class AbstractSlingoAnimationSpriteProperties extends AbstractSlingoAnimationProperties {
    equals(other) {
        return super.equals(other) &&
            this.animationProperties.equals(other.animationProperties);
    }
    setDefaultValues() {
        super.setDefaultValues();
        this.animationProperties = new MovieClipProperties(SlingoStyle.SLINGO, SlingoStyle.MODULE, 32);
    }
}
/**
 * AbstractSlingoAnimationSpriteProperties.ts
 */
export class AbstractSlingoAnimationSpineProperties extends AbstractSlingoAnimationProperties {
    equals(other) {
        return super.equals(other) &&
            this.animationProperties.equals(other.animationProperties) &&
            this.hasMultiple === other.hasMultiple &&
            this.singleAnimationName === other.singleAnimationName &&
            this.multiAnimationName === other.multiAnimationName &&
            ArrayUtil.equals(this.animationNameArray, other.animationNameArray);
    }
    setDefaultValues() {
        super.setDefaultValues();
        this.animationProperties = new SpineProperties(SlingoStyle.SLINGO, SlingoStyle.MODULE);
        this.hasMultiple = false;
        this.singleAnimationName = "slingo";
        this.multiAnimationName = "slingos";
        this.animationNameArray = null;
    }
}
//# sourceMappingURL=AbstractSlingoAnimationProperties.js.map